import Close from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import makeStyles from '@mui/styles/makeStyles';
import { orderBy } from 'lodash';
import React, { useContext } from 'react';
import Carousel from 'react-material-ui-carousel';
import { AdContext } from '../../contexts/ads-context';
import { uicolors } from '../../theme';
import { BannerItem } from './banner-item';

const useStyles = makeStyles((theme) => ({
  indicatorContainer: {
    position: 'absolute',
    right: 0,
    left: 0,
    bottom: 2,
  },
  indicatorButtons: {
    color: uicolors.blue[300],
    opacity: 0.5,
    margin: '0px 1px',
    border: '0px solid black',
    padding: 0,
  },
}));

export function BannerCarousel() {
  // Context
  const { state } = useContext(AdContext);
  // Hooks
  const classes = useStyles();
  // State
  const [hideBanner, setHideBanner] = React.useState(true);

  React.useEffect(() => {
    if (!window.sessionStorage.getItem('hideBanner')) {
      setHideBanner(false);
    }
  }, []);

  if (state.banners.length > 0 && !hideBanner) {
    return (
      <Box
        sx={{
          backgroundColor: '#17191b',
        }}
      >
        <IconButton
          size="small"
          sx={{
            zIndex: 1,
            color: uicolors.blue[300],
            position: 'absolute',
            top: 8,
            right: 8,
            borderColor: 'transparent',
          }}
          onClick={() => {
            window.sessionStorage.setItem('hideBanner', 'true');
            setHideBanner(true);
          }}
        >
          <Close sx={{ opacity: 0.8 }} />
        </IconButton>
        <Carousel
          autoPlay={true}
          interval={7000}
          navButtonsAlwaysInvisible
          indicatorContainerProps={{
            className: classes.indicatorContainer,
          }}
          activeIndicatorIconButtonProps={{
            style: {
              opacity: 1,
            },
          }}
          indicatorIconButtonProps={{
            className: classes.indicatorButtons,
          }}
        >
          {orderBy(state.banners, 'OrderIndex', 'asc').map((item) => {
            return (
              <Box
                key={item.AdId}
                width="100%"
                sx={{
                  pt: { xs: 0, md: 2 },
                  pb: 3,
                  display: hideBanner ? 'none' : 'inherit',
                  position: 'relative',
                  background: `linear-gradient(135deg, ${item.BGColor}33 0%, ${item.BGColor}18 40%, #1e1e1e 100%)`,
                  borderBottom: '1px solid',
                  borderBottomColor: `${item.BGColor}40`,
                }}
              >
                <BannerItem data={item} />
              </Box>
            );
          })}
        </Carousel>
      </Box>
    );
  } else {
    return null;
  }
}
